import {
  SET_DASHBOARD,
  SET_DEBTORS,
  SET_CREDITORS,
  SET_RECIEVE_CHEQUES,
  SET_PAYMENT_CHEQUES,
  SET_DASHBOARD_FINANCIALS,
  SET_TOPSALES,
  SET_TOPBUYS,
  SET_BUYFACTOR,
  SET_SELLFACTOR,
  SET_PROFIT_AND_LOSS,
  SET_LATEST_ACCOUNTINGS,
  SET_SALES_CHART,
  SET_BUYS_CHART,
  SET_INCOMES_CHART,
  SET_COSTS_CHART,
} from "../../constants/dashboardConstants";

export const setDashboard = (dashboard) => {
  return {
    type: SET_DASHBOARD,
    dashboard,
  };
};
export const setDebtors = (debtors) => {
  return {
    type: SET_DEBTORS,
    debtors,
  };
};
export const setCreditors = (creditors) => {
  return {
    type: SET_CREDITORS,
    creditors,
  };
};
export const setRecieveCheques = (receiveCheques) => {
  return {
    type: SET_RECIEVE_CHEQUES,
    receiveCheques,
  };
};
export const setPaymentCheques = (paymentCheques) => {
  return {
    type: SET_PAYMENT_CHEQUES,
    paymentCheques,
  };
};

export const setDashboardFinancials = (financials) => {
  return {
    type: SET_DASHBOARD_FINANCIALS,
    financials,
  };
};
export const setTopSales = (topSales) => {
  return {
    type: SET_TOPSALES,
    topSales,
  };
};
export const setTopBuys = (topBuys) => {
  return {
    type: SET_TOPBUYS,
    topBuys,
  };
};
export const setBuyFactor = (buyFactor) => {
  return {
    type: SET_BUYFACTOR,
    buyFactor,
  };
};
export const setSellFactor = (sellFactor) => {
  return {
    type: SET_SELLFACTOR,
    sellFactor,
  };
};
export const setProfitAndLoss = (profitAndLoss) => {
  return {
    type: SET_PROFIT_AND_LOSS,
    profitAndLoss,
  };
};
export const setLatestAccountings = (latestAccountings) => {
  return {
    type: SET_LATEST_ACCOUNTINGS,
    latestAccountings,
  };
};
export const setSalesChart = (salesChart) => {
  return {
    type: SET_SALES_CHART,
    salesChart,
  };
};
export const setBuysChart = (buysChart) => {
  return {
    type: SET_BUYS_CHART,
    buysChart,
  };
};
export const setIncomesChart = (incomesChart) => {
  return {
    type: SET_INCOMES_CHART,
    incomesChart,
  };
};
export const setCostsChart = (costsChart) => {
  return {
    type: SET_COSTS_CHART,
    costsChart,
  };
};
